import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=69395d54&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=69395d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69395d54",
  null
  
)

export default component.exports